import { render, staticRenderFns } from "./DomainSummaryTop5Dealer.vue?vue&type=template&id=0a5d62e6&scoped=true"
import script from "./DomainSummaryTop5Dealer.vue?vue&type=script&lang=js"
export * from "./DomainSummaryTop5Dealer.vue?vue&type=script&lang=js"
import style0 from "./DomainSummaryTop5Dealer.vue?vue&type=style&index=0&id=0a5d62e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5d62e6",
  null
  
)

export default component.exports